import React from 'react';
import Layout from '../components/layout/Layout';
import { companyInfo } from '../data/mock';

const CookiesPage = () => {
  return (
    <Layout>
      <section className="bg-white py-16">
        <div className="container-main">
          <h1 className="text-4xl md:text-5xl font-bold text-navy font-display mb-8">Cookie Policy</h1>
          
          <div className="max-w-3xl prose prose-lg text-gray-600">
            <p className="text-sm text-gray-500 mb-8">Last updated: August 2025</p>
            
            <h2 className="text-2xl font-bold text-navy mt-8 mb-4">1. What Are Cookies</h2>
            <p className="mb-4 leading-relaxed">
              Cookies are small text files that are stored on your device when you visit our website. They help us provide you with a better experience by remembering your preferences and understanding how you use our site.
            </p>

            <h2 className="text-2xl font-bold text-navy mt-8 mb-4">2. Types of Cookies We Use</h2>
            
            <h3 className="text-xl font-semibold text-navy mt-6 mb-3">Essential Cookies</h3>
            <p className="mb-4 leading-relaxed">
              These cookies are necessary for the website to function properly. They enable basic functions like page navigation and access to secure areas of the website.
            </p>

            <h3 className="text-xl font-semibold text-navy mt-6 mb-3">Analytics Cookies</h3>
            <p className="mb-4 leading-relaxed">
              We use analytics cookies to understand how visitors interact with our website. This helps us improve our website and services.
            </p>

            <h3 className="text-xl font-semibold text-navy mt-6 mb-3">Functional Cookies</h3>
            <p className="mb-4 leading-relaxed">
              These cookies enable enhanced functionality and personalization, such as remembering your preferences and settings.
            </p>

            <h2 className="text-2xl font-bold text-navy mt-8 mb-4">3. Managing Cookies</h2>
            <p className="mb-4 leading-relaxed">
              You can control and manage cookies in your browser settings. Please note that removing or blocking cookies may impact your user experience and some features may no longer be available.
            </p>

            <h2 className="text-2xl font-bold text-navy mt-8 mb-4">4. Third-Party Cookies</h2>
            <p className="mb-4 leading-relaxed">
              Some cookies on our website are set by third-party services that appear on our pages. We do not control these cookies and recommend reviewing the privacy policies of these third parties.
            </p>

            <h2 className="text-2xl font-bold text-navy mt-8 mb-4">5. Updates to This Policy</h2>
            <p className="mb-4 leading-relaxed">
              We may update this Cookie Policy from time to time. Any changes will be posted on this page with an updated revision date.
            </p>

            <h2 className="text-2xl font-bold text-navy mt-8 mb-4">6. Contact Us</h2>
            <p className="mb-4 leading-relaxed">
              If you have any questions about our use of cookies, please contact us at:
            </p>
            <p className="mb-2">{companyInfo.name}</p>
            <p className="mb-2">{companyInfo.address}</p>
            <p className="mb-2">Email: {companyInfo.email}</p>
            <p className="mb-2">Phone: {companyInfo.phone}</p>
          </div>
        </div>
      </section>
    </Layout>
  );
};

export default CookiesPage;
